import { createAsyncThunk } from "@reduxjs/toolkit";
import apiService from "../../../../services/apiService";
import { REPORT_FLOW_SLICE_NAME } from "../../sliceConstants";

const reportThunkActions = {
  fetchReportDetails: createAsyncThunk(
    `${REPORT_FLOW_SLICE_NAME}/fetchReportDetails`,
    async (body, { rejectWithValue, dispatch }) => {
      try {
        const res = await apiService.fetchReportDetails(body);
        return res?.data || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  fetchAchievementDetails: createAsyncThunk(
    `${REPORT_FLOW_SLICE_NAME}/fetchAchievementDetails`,
    async (body, { rejectWithValue, dispatch }) => {
      try {
        const res = await apiService.fetchAchievementDetails(body);
        return res?.data || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  fetchAchievementDetailsCategoryWise: createAsyncThunk(
    `${REPORT_FLOW_SLICE_NAME}/fetchAchievementDetailsCategoryWise`,
    async (body, { rejectWithValue, dispatch }) => {
      try {
        const res = await apiService.fetchAchievementDetailsCategoryWise(body);
        return res?.data || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  getTargetFilters: createAsyncThunk(
    `${REPORT_FLOW_SLICE_NAME}/getTargetFilters`,
    async (body, { rejectWithValue, dispatch }) => {
      try {
        const res = await apiService.getTargetFilters(body);
        return res?.data || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  fetchAchievementDetailsFilterWise: createAsyncThunk(
    `${REPORT_FLOW_SLICE_NAME}/fetchAchievementDetailsFilterWise`,
    async (body, { rejectWithValue, dispatch }) => {
      try {
        const res = await apiService.fetchAchievementDetailsFilterWise(body);
        return res?.data || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  fetchFocussedSku: createAsyncThunk(
    `${REPORT_FLOW_SLICE_NAME}/fetchFocussedSku`,
    async (body, { rejectWithValue, dispatch }) => {
      try {
        const res = await apiService.fetchFocussedSku(body);
        return res?.data || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  fetchIncentives: createAsyncThunk(
    `${REPORT_FLOW_SLICE_NAME}/fetchIncentives`,
    async (body, { rejectWithValue }) => {
      try {
        const res = await apiService.fetchIncentives(body);
        return res?.data || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  getSubordinateFilter: createAsyncThunk(
    `${REPORT_FLOW_SLICE_NAME}/getSubordinateFilter`,
    async (id, { rejectWithValue }) => {
      try {
        const res = await apiService.getSubordinateFilter(id);
        return res || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  getSubordinates: createAsyncThunk(
    `${REPORT_FLOW_SLICE_NAME}/getSubordinates`,
    async (id, { rejectWithValue }) => {
      try {
        const res = await apiService.getSubordinates(id);
        return res || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  fetchTargetAchievementData: createAsyncThunk(
    `${REPORT_FLOW_SLICE_NAME}/fetchTargetAchievementData`,
    async (body, { rejectWithValue }) => {
      try {
        const res = await apiService.fetchTargetAchievementData(body);
        return res?.data || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  getSubordinatesForRole: createAsyncThunk(
    `${REPORT_FLOW_SLICE_NAME}/getSubordinatesForRole`,
    async (role, { rejectWithValue }) => {
      try {
        const res = await apiService.getSubordinatesForRole(role);
        return res || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  getAllManagersForRole: createAsyncThunk(
    `${REPORT_FLOW_SLICE_NAME}/getAllManagersForRole`,
    async (params, { rejectWithValue }) => {
      try {
        const res = await apiService.getAllManagersForRole(params);
        console.log("MANAGER API RAW RESPONSE:", res.data);
        
        // Check if this is a retailer API response
        if (params.role && params.role.toUpperCase() === "RETAILER") {
          // Retailer API response format: { partnerName, prmId }
          const data = JSON.parse(res.data);
          const retailerData = data?.data || [];
          
          console.log("Retailer API response data:", retailerData);
          
          // Transform retailer data to match employee list format
          const transformedData = retailerData.map((retailer) => {
            // Ensure we have prmId - it's the primary identifier for retailers
            const prmId = retailer.prmId || retailer.id;
            const partnerName = retailer.partnerName || retailer.label || retailer.name || "";
            
            if (!prmId) {
              console.warn("Retailer missing prmId:", retailer);
            }
            
            const transformed = {
              id: prmId, // Employee ID for filter modal - MUST be present
              label: partnerName, // Display name
              partnerName: partnerName, // For API calls
              employee_id: prmId, // Alternative ID field
              name: partnerName, // Alternative name field
            };
            
            console.log("Transformed retailer:", transformed);
            return transformed;
          });
          
          console.log("Transformed retailer data:", transformedData);
          return transformedData;
        }
        
        // Regular subordinates API response
        const dt = JSON.parse(res.data)?.data || [];
        return dt || [];
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  fetchEmployeeSummary: createAsyncThunk(
    `${REPORT_FLOW_SLICE_NAME}/fetchEmployeeSummary`,
    async (body, { rejectWithValue }) => {
      try {
        const res = await apiService.fetchEmployeeSummary(body);
        const data = JSON.parse(res.data);
        // New API response structure: { updatedAt: "...", summary: [...] }
        return data?.data || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  searchEmployeeSummary: createAsyncThunk(
    `${REPORT_FLOW_SLICE_NAME}/searchEmployeeSummary`,
    async (body, { rejectWithValue }) => {
      try {
        const res = await apiService.searchEmployeeSummary(body);
        const data = JSON.parse(res.data);
        return data?.data || [];
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
};

export default reportThunkActions;
